import React, { useState } from "react";
import styled from "styled-components";

const SliderContainer = styled.div`
  width: 80%;
  max-width: 600px;
  margin: 20px;
  text-align: center;
`;

const Slider = styled.input.attrs({ type: "range" })`
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  background: #ddd;
  height: 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  transition: background 0.3s;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: #2e186a;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    background: #2e186a;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
  }
`;

const SliderInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const CurrentPrice = styled.span`
  color: #2e186a;
  font-weight: bold;
  font-size: 24px;
  font-family: "Motiva Sans Light", sans-serif;
`;

const PriceSlider = () => {
  const evalPrice = (n:any) => {
    const p = Math.pow(n - 50, 2 / 4) * 5;
    return Math.floor(p);
  };

  const [{ value, price }, setValue] = useState({ value: 10000, price: evalPrice(10000) });

  const handleChange = (e: any) => {
    const v = e.target.value
    const p = evalPrice(v)
    if (v == 0) setValue({ value: 0, price: 0 });
    else setValue({ value: v, price: p });
  };

  return (
    <SliderContainer>
      <Slider
        min="0"
        max="100000"
        step="100"
        value={value}
        onChange={handleChange}
      />
      <SliderInfo>
        <CurrentPrice>
          {value} of records for ${price}
        </CurrentPrice>
      </SliderInfo>
    </SliderContainer>
  );
};

export default PriceSlider;
